
export default {
	initData: '/companies/change-infos/init',
	saveCompany: '/companies',
	updateCompany: '/companies/:id',
	getCompanyDetail: 'companies/:id',
	getCompanyPreview: '/companies/:id/preview',
	linkedProperties: '/companies/:id/properties',
	propertyProposal: '/companies/:id/proposal',
	demandProposal: '/companies/:id/proposal-demand',
    autoComplete: '/companies/auto-complete?startName=:startName',
    information: '/companies/infomation',
    generateCBE: '/companies/generate-cbe'
}